const svg = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="84.27px" height="84.27px" viewBox="0 0 84.27 84.27" enable-background="new 0 0 84.27 84.27" xml:space="preserve">
<polygon fill-rule="evenodd" clip-rule="evenodd" points="42.134,14.045 52.32,18.373 62.506,22.701 66.727,33.149 70.947,43.599 
	66.727,54.046 62.506,64.495 52.32,68.823 42.134,73.151 31.948,68.823 21.761,64.495 17.542,54.046 13.321,43.599 17.542,33.149 
	21.761,22.701 31.948,18.373 "/>
</svg>`
export { svg };